//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import FormDrawer from './components/FormDrawer.vue'
import EditDrawer from './components/EditDrawer.vue'
import { sportType_list, sportType_del } from '@/apis/config'
export default {
    components: {
        FormDrawer,
        EditDrawer
    },
    data() {
        return {
            loading: false,
            data: [],
            columns: [],
            rowSelection: {},
            formState: {
                typeCode: '',
                name: '',
            },
            pagination: {
                current: 1,
                pageSize: 10,
                total: 0
            }
        }
    },
    created() {
        this.columns.push({ title: '運動編號', dataIndex: 'typeCode', key: 'typeCode', })
        this.columns.push({ title: '運動名稱', dataIndex: 'name', key: 'name', })
        this.columns.push({ title: '圖片', dataIndex: 'imageUrl', key: 'imageUrl', scopedSlots: { customRender: 'imageUrl' }, })
        this.columns.push({ title: '狀態', dataIndex: 'status', key: 'status', scopedSlots: { customRender: 'status' }, })
        this.columns.push({ title: '操作', key: 'operation', width: 280, scopedSlots: { customRender: 'action' }, });
    },
    mounted() {
        this.onPageLoad();
    },
    methods: {
        async onPageLoad(isPostBack) {
            if (this.loading) return;
            if (!isPostBack) {
                this.pagination.current = 1;
            }

            try {
                this.loading = true;
                //加載運動類型
                const params = {
                    ...this.formState,
                    pageNumber: this.pagination.current,
                    pageSize: this.pagination.pageSize
                };
                const res = await sportType_list(params);
                this.data = res.data.records;
                this.pagination.total = res.data.total;
            } catch (error) {
                this.$message.error(error.message);
            } finally {
                this.loading = false;
            }
        },
        handleSearchSubmit(e) {
            e.preventDefault();
            this.onPageLoad();
        },
        handleAdd() {
            this.$refs.formDrawer.showDrawer();
        },
        handleEdit(item) {
            this.$refs.editDrawer.showDrawer(item.id);
        },
        //刪除行
        async handleOnDelete(item) {
            try {
                const res = await sportType_del(item.id) || {};
                if (res.code == 0) {
                    this.onPageLoad(true);
                } else {
                    if (res.msg) throw new Error(res.msg);
                }
            } catch (error) {
                console.log('delete error', error);
                this.$message.error(error.message);
            }
        },
        onFormSubmit() {
            this.onPageLoad();
        },
        onEditSubmit() {
            this.onPageLoad();
        },
    }
}
